import { Component, Input, OnInit } from '@angular/core';
import { Partner } from '../../../../../models/partner.model';
import { TableElementComponent } from '@uranda/ui';

@Component({
    selector: 'app-partner-verified-icon',
    templateUrl: './partner-verified-icon.component.html',
    styleUrls: ['./partner-verified-icon.component.css'],
    standalone: false
})
export class PartnerVerifiedIconComponent extends TableElementComponent {

  get isVerified(): boolean {
    if (this.props.verificationType === 'email') {
      return !!(this.data.account?.emailVerifiedAt);
    } else if (this.props.verificationType === 'phone') {
      return !!(this.data.account?.phoneVerifiedAt);
    }
    return false;
  }
}